module.exports = __webpack_public_path__ + "static/media/facebook-container.a76c569d.svg";